"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PonziBalanceButton = exports.PONZI_VIEW_DIALOG_KEY = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const icons_material_1 = require("@mui/icons-material");
const styled_1 = require("@framework/styled");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const utils_1 = require("../../../../utils");
const view_1 = require("./view");
exports.PONZI_VIEW_DIALOG_KEY = "ponziBalanceView";
const PonziBalanceButton = (props) => {
    const { className, contract, contract: { address }, disabled, variant, } = props;
    const { openViewDialog, closeViewDialog, viewDialogUniqueKey, viewMode } = (0, react_hooks_1.useDialogView)();
    const handlePonziBalance = () => {
        openViewDialog(exports.PONZI_VIEW_DIALOG_KEY, contract, "action");
    };
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handlePonziBalance, icon: icons_material_1.MonetizationOn, message: "form.buttons.ponziBalance", className: className, dataTestId: "PonziBalanceButton", disabled: disabled || (0, utils_1.shouldDisableByContractType)(contract), variant: variant }), (0, jsx_runtime_1.jsx)(view_1.PonziBalanceDialog, { onCancel: closeViewDialog, onConfirm: closeViewDialog, open: viewDialogUniqueKey === `${exports.PONZI_VIEW_DIALOG_KEY}.${viewMode}`, data: { address } })] }));
};
exports.PonziBalanceButton = PonziBalanceButton;
//# sourceMappingURL=index.js.map